export const OFFER_TYPE_COLORS: Record<string, string> = {
  DIGITAL:  'bg-shell text-white',
  PHYSICAL: 'bg-citrus text-slate-800',
  SERVICE:  'bg-teal-600 text-white',
}

const SIZES = {
  sm: 'px-2 py-0.5 text-[9px]',
  md: 'px-2.5 py-0.5 text-[10px]',
  lg: 'px-3 py-1 text-xs',
}

interface OfferTypeChipProps {
  offerType: string
  size?: 'sm' | 'md' | 'lg'
}

export function OfferTypeChip({ offerType, size = 'md' }: OfferTypeChipProps) {
  const colors = OFFER_TYPE_COLORS[offerType]
  if (!colors) return null
  return (
    <span className={`inline-flex items-center rounded-full font-bold uppercase tracking-wide flex-shrink-0 ${SIZES[size]} ${colors}`}>
      {offerType}
    </span>
  )
}
